import * as React from "react";

const DesignerIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} {...props}>
  <title>{"Designer"}</title>
  <g fill={props.fill} fillRule="nonzero">
    <path d="M.358 15.972a.533.533 0 0 1-.33-.675L5 .365A.528.528 0 0 1 5.501 0c.227 0 .425.148.5.365l4.971 14.932a.527.527 0 1 1-.998.341L5.501 2.207 1.03 15.638a.54.54 0 0 1-.671.334Z" />
    <path d="M2 11h8v1H2zM23.482 16h-9.965a.514.514 0 0 1-.456-.286.55.55 0 0 1 .03-.552l9.406-14.095h-7.313a.528.528 0 0 1-.518-.534c0-.293.233-.533.518-.533h8.298c.193 0 .368.11.457.286a.547.547 0 0 1-.03.552l-9.408 14.095h8.98c.285 0 .518.24.518.534a.527.527 0 0 1-.517.533Z" />
    <path d="M15.4 6h-4.8c-.33 0-.6-.225-.6-.5s.27-.5.6-.5h4.8c.33 0 .6.225.6.5s-.27.5-.6.5Z" />
    <path d="M14.183 7.905c-.213-.15-.244-.417-.07-.598l1.74-1.806-1.74-1.805c-.174-.182-.143-.448.07-.6a.562.562 0 0 1 .703.059l2 2.075a.38.38 0 0 1 0 .541l-2 2.076a.55.55 0 0 1-.387.153.561.561 0 0 1-.316-.095Z" />
  </g>
</svg>
);

export default DesignerIcon;
